/**
 * @returns
 * @note `SvgIcon` 컴포넌트를 사용하지 않음.
 */
export default function SFHamburgerIcon() {
  return (
    // <SvgIcon {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7169 19L4 19M4.00041 12L20 12M4 5L11.0281 5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>

    // </SvgIcon>
  );
}
